import { usePaginatedQuery } from '../../hooks';
import { useHealthInsuranceInfiniteQuery } from './query';

export const useHealthInsuranceNames = (type: string | undefined) => {
  const infiniteQuery = useHealthInsuranceInfiniteQuery(type);
  return usePaginatedQuery(infiniteQuery, 'Health Insurance');
};
